import { z } from 'zod';

/**
 * We previously used `validator`'s `isISO8601` to check for ISO date. This is their date validation
 * regex, lifted verbatim to get rid of the dependency.
 *
 * We can't use `z.iso.datetime()` because it is narrower: It rejects offset timestamps
 * (`2020-08-04T13:56:16+00:00`), date-only values, basic (dash-less) format, week and ordinal
 * dates, and a space separator.
 *
 * Note what it does not do: without validator's `strict` option this checks shape only, so
 * impossible dates such as 2009-02-31 pass.
 */
const iso8601 =
  // eslint-disable-next-line no-useless-escape
  /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;

export function isISO8601(str: string): boolean {
  return iso8601.test(str);
}

export const schemaISODateString = z.string().regex(iso8601);
